import { render, staticRenderFns } from "./VehiclesIndex.vue?vue&type=template&id=bbb91dda"
import script from "./VehiclesIndex.vue?vue&type=script&lang=js"
export * from "./VehiclesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports